const RESOURCE_TEXT_TRANSLATIONS = {
  es: {
    "Food Pantry": "Despensa de alimentos",
    "Food Pantries": "Despensas de alimentos",
    "Family Assistance": "Asistencia familiar",
    "Legal Aid": "Ayuda legal",
    "Food": "Comida",
    "Shelter": "Refugio",
    "Benefits": "Beneficios",
    "Crisis": "Crisis",
    "Community": "Comunidad",
    "Needs verification": "Necesita verificacion",
    "Call ahead": "Llame antes de ir",
    "Call for hours": "Llame para confirmar horario",
    "Monday": "Lunes",
    "Tuesday": "Martes",
    "Wednesday": "Miercoles",
    "Thursday": "Jueves",
    "Friday": "Viernes",
    "Saturday": "Sabado",
    "Sunday": "Domingo",
    "Daily": "Diario",
    "Monday-Friday": "Lunes-viernes",
    "Monday-Thursday": "Lunes-jueves",
    "4th Wednesday": "Cuarto miercoles",
    "Second Saturday": "Segundo sabado",
    "First and Third Saturday": "Primer y tercer sabado",
    "choice pantry": "despensa de eleccion",
    "no appointment needed": "no se necesita cita",
    "no paperwork": "sin papeleo",
    "no fee": "sin costo",
    "self-pickup": "recogida por cuenta propia",
    "emergency assistance": "asistencia de emergencia",
    "utility help": "ayuda con servicios publicos",
    "rent support": "ayuda con alquiler",
    "donations accepted daily 2-4 PM": "donaciones aceptadas todos los dias 2-4 PM",
    "mental health": "salud mental",
    "counseling": "consejeria",
    "support groups": "grupos de apoyo",
    "twice weekly": "dos veces por semana",
    "twice monthly": "dos veces al mes",
    "extended hours": "horario extendido",
    "seniors 55+": "personas mayores de 55",
    "register by 10 AM": "registrarse antes de las 10 AM",
    "emergency food": "comida de emergencia",
    "no residency requirement": "sin requisito de residencia",
    "township services": "servicios municipales",
    "referrals": "referencias",
    "walk-in": "sin cita",
    "fresh produce": "productos frescos",
    "no ID required": "no se requiere identificacion",
    "evening hours": "horario nocturno",
    "Chester families": "familias de Chester",
    "SNAP enrollment": "inscripcion a SNAP",
    "employment": "empleo",
    "daily service": "servicio diario",
    "hot meals": "comidas calientes",
    "clothing": "ropa",
    "free legal help": "ayuda legal gratuita",
    "housing": "vivienda",
    "family law": "derecho familiar",
    "borough residents": "residentes del municipio",
    "senior services": "servicios para mayores",
    "Saturday pantry": "despensa de alimentos de sabado",
    "Lansdowne residents": "residentes de Lansdowne",
    "job training": "capacitacion laboral",
    "financial counseling": "asesoria financiera",
    "monthly distribution": "distribucion mensual",
    "Ridley Park": "Ridley Park",
    "Thursday evening": "jueves por la noche",
    "Ridley area": "area de Ridley",
    "Springfield Township": "Springfield Township",
    "Swarthmore area": "area de Swarthmore",
    "township residents": "residentes del municipio",
    "Drexel Hill": "Drexel Hill",
    "diapers": "panales",
    "pet supplies": "suministros para mascotas",
    "referral hub": "centro de referencias",
    "essentials": "articulos esenciales",
    "housing help": "ayuda de vivienda",
    "legal aid": "ayuda legal",
    "eviction defense": "defensa contra desalojo",
    "benefits access": "acceso a beneficios",
    "women": "mujeres",
    "housing instability": "inestabilidad de vivienda",
    "financial hardship": "dificultad financiera",
    "all services": "todos los servicios",
    "24/7": "24/7",
    "bilingual": "bilingue"
  },
  vi: {
    "Food Pantry": "Kho thuc pham",
    "Family Assistance": "Ho tro gia dinh",
    "Legal Aid": "Tro giup phap ly",
    "Food": "Thuc pham",
    "Shelter": "Noi tam tru",
    "Benefits": "Phuc loi",
    "Crisis": "Khung hoang",
    "Community": "Cong dong",
    "Needs verification": "Can xac minh",
    "Call ahead": "Goi truoc khi den",
    "Call for hours": "Goi de xac nhan gio",
    "Monday": "Thu Hai",
    "Tuesday": "Thu Ba",
    "Wednesday": "Thu Tu",
    "Thursday": "Thu Nam",
    "Friday": "Thu Sau",
    "Saturday": "Thu Bay",
    "Sunday": "Chu Nhat",
    "Daily": "Hang ngay",
    "Monday-Friday": "Thu Hai-Thu Sau",
    "Monday-Thursday": "Thu Hai-Thu Nam",
    "4th Wednesday": "Thu Tu thu tu",
    "Second Saturday": "Thu Bay thu hai",
    "First and Third Saturday": "Thu Bay dau va thu ba",
    "choice pantry": "kho thuc pham tu chon",
    "no appointment needed": "khong can hen truoc",
    "no paperwork": "khong can giay to",
    "no fee": "mien phi",
    "self-pickup": "tu den nhan",
    "emergency assistance": "ho tro khan cap",
    "utility help": "ho tro tien dien nuoc",
    "rent support": "ho tro tien nha",
    "donations accepted daily 2-4 PM": "nhan quyen gop hang ngay 2-4 PM",
    "mental health": "suc khoe tam than",
    "counseling": "tu van",
    "support groups": "nhom ho tro",
    "twice weekly": "hai lan moi tuan",
    "twice monthly": "hai lan moi thang",
    "extended hours": "gio mo rong",
    "seniors 55+": "nguoi cao tuoi 55+",
    "register by 10 AM": "dang ky truoc 10 AM",
    "emergency food": "thuc pham khan cap",
    "no residency requirement": "khong yeu cau cu tru",
    "township services": "dich vu dia phuong",
    "referrals": "gioi thieu dich vu",
    "walk-in": "khong can hen",
    "fresh produce": "rau qua tuoi",
    "no ID required": "khong can giay to tuy than",
    "evening hours": "gio buoi toi",
    "Chester families": "gia dinh Chester",
    "SNAP enrollment": "dang ky SNAP",
    "employment": "viec lam",
    "daily service": "dich vu hang ngay",
    "hot meals": "bua an nong",
    "clothing": "quan ao",
    "free legal help": "tro giup phap ly mien phi",
    "housing": "nha o",
    "family law": "luat gia dinh",
    "borough residents": "cu dan borough",
    "senior services": "dich vu cho nguoi cao tuoi",
    "Saturday pantry": "kho thuc pham thu Bay",
    "Lansdowne residents": "cu dan Lansdowne",
    "job training": "dao tao viec lam",
    "financial counseling": "tu van tai chinh",
    "monthly distribution": "phan phat hang thang",
    "Ridley Park": "Ridley Park",
    "Thursday evening": "toi thu Nam",
    "Ridley area": "khu vuc Ridley",
    "Springfield Township": "Springfield Township",
    "Swarthmore area": "khu vuc Swarthmore",
    "township residents": "cu dan dia phuong",
    "Drexel Hill": "Drexel Hill",
    "diapers": "ta em be",
    "pet supplies": "do dung thu cung",
    "referral hub": "trung tam gioi thieu",
    "essentials": "do thiet yeu",
    "housing help": "ho tro nha o",
    "legal aid": "tro giup phap ly",
    "eviction defense": "ho tro chong truc xuat",
    "benefits access": "tiep can phuc loi",
    "women": "phu nu",
    "housing instability": "bat on nha o",
    "financial hardship": "kho khan tai chinh",
    "all services": "tat ca dich vu",
    "24/7": "24/7",
    "bilingual": "song ngu"
  },
  zh: {
    "Food Pantry": "食品救济点",
    "Family Assistance": "家庭援助",
    "Legal Aid": "法律援助",
    "Food": "食物",
    "Shelter": "庇护",
    "Benefits": "福利",
    "Crisis": "危机",
    "Community": "社区",
    "Needs verification": "需要核实",
    "Call ahead": "前往前请致电",
    "Call for hours": "请致电确认时间",
    "Monday": "星期一",
    "Tuesday": "星期二",
    "Wednesday": "星期三",
    "Thursday": "星期四",
    "Friday": "星期五",
    "Saturday": "星期六",
    "Sunday": "星期日",
    "Daily": "每天",
    "Monday-Friday": "星期一至星期五",
    "Monday-Thursday": "星期一至星期四",
    "4th Wednesday": "第四个星期三",
    "Second Saturday": "第二个星期六",
    "First and Third Saturday": "第一个和第三个星期六",
    "choice pantry": "自选食品救济点",
    "no appointment needed": "无需预约",
    "no paperwork": "无需文件",
    "no fee": "免费",
    "self-pickup": "自行领取",
    "emergency assistance": "紧急援助",
    "utility help": "水电煤援助",
    "rent support": "租金援助",
    "donations accepted daily 2-4 PM": "每天 2-4 PM 接受捐赠",
    "mental health": "心理健康",
    "counseling": "咨询",
    "support groups": "支持小组",
    "twice weekly": "每周两次",
    "twice monthly": "每月两次",
    "extended hours": "延长时间",
    "seniors 55+": "55 岁以上长者",
    "register by 10 AM": "上午 10 点前登记",
    "emergency food": "紧急食品",
    "no residency requirement": "无居住要求",
    "township services": "镇区服务",
    "referrals": "转介",
    "walk-in": "可直接前往",
    "fresh produce": "新鲜农产品",
    "no ID required": "无需身份证件",
    "evening hours": "晚间时间",
    "Chester families": "Chester 家庭",
    "SNAP enrollment": "SNAP 登记",
    "employment": "就业",
    "daily service": "每日服务",
    "hot meals": "热餐",
    "clothing": "衣物",
    "free legal help": "免费法律帮助",
    "housing": "住房",
    "family law": "家庭法",
    "borough residents": "自治市居民",
    "senior services": "长者服务",
    "Saturday pantry": "星期六食品点",
    "Lansdowne residents": "Lansdowne 居民",
    "job training": "职业培训",
    "financial counseling": "财务咨询",
    "monthly distribution": "每月发放",
    "Ridley Park": "Ridley Park",
    "Thursday evening": "星期四晚上",
    "Ridley area": "Ridley 地区",
    "Springfield Township": "Springfield Township",
    "Swarthmore area": "Swarthmore 地区",
    "township residents": "镇区居民",
    "Drexel Hill": "Drexel Hill",
    "diapers": "尿布",
    "pet supplies": "宠物用品",
    "referral hub": "转介中心",
    "essentials": "生活必需品",
    "housing help": "住房帮助",
    "legal aid": "法律援助",
    "eviction defense": "驱逐辩护",
    "benefits access": "福利申请帮助",
    "women": "女性",
    "housing instability": "住房不稳定",
    "financial hardship": "财务困难",
    "all services": "所有服务",
    "24/7": "全天候",
    "bilingual": "双语"
  }
};

function normalizeResourceText(value) {
  return String(value || "").replace(/\s+/g, " ").replace(/–/g, "-").trim();
}

export function translateResourceText(value, lang = "en") {
  if (value === undefined || value === null) return value;
  if (!lang || lang === "en") return value;
  const original = String(value);
  const normalized = normalizeResourceText(original);
  const translated = RESOURCE_TEXT_TRANSLATIONS[lang]?.[original] || RESOURCE_TEXT_TRANSLATIONS[lang]?.[normalized];
  return translated || RESOURCE_TEXT_TRANSLATIONS.en?.[normalized] || original;
}
